export interface IAdvertContact {
  name: string;
  phone?: number;
}
export interface IAdvertImage {
  url: string;
}
export interface IAdvertLocation {
  city_id: number;
  district_id: null;
  latitude: number;
  longitude: number;
}


export interface IAdvert {
  type: ADVERT_TYPE;
  id: number;
  title: string;
  activated_at: string;
  advertiser_type: string;
  attributes: any[];
  category_id: number;
  category: any;
  contact: IAdvertContact;
  courier: null;
  created_at: string;
  description: string;
  external_id: number;
  external_url: string;
  images: IAdvertImage[];
  location: IAdvertLocation;
  address: any;
  price: {
    value: number;
    currency: string;
    trade: boolean;
    negotiable: boolean;
  };
  double_price: {
    usd: string;
    uah: string;
  };
  salary: null;
  status: string;
  url: string;
  valid_to: string;
}

export enum ADVERT_TYPE {
  OLX = 'OLX',
  RIA = 'RIA',
}

export interface IAction {
  title: string;
  icon: string;
  key: string;
  action: () => void;
  is_disabled?: boolean;
}
